import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import Vuetify from 'vuetify'

import enMessages from './en.json'
import jaMessages from './ja.json'
import thMessages from './th.json'

Vue.use(VueI18n)

const messages = {
  en: enMessages,
  ja: jaMessages,
  th: thMessages,
}

const i18n = new VueI18n({
  locale: 'en', // overwritten by applyLocale() on the first navigation
  messages,
})

// Vuetify is constructed in main.ts, so it is handed to us instead of imported.
let vuetifyInstance: Vuetify | null = null

export const registerVuetify = (v: Vuetify): void => {
  vuetifyInstance = v
}

// Applies a locale to every consumer that is not driven by i18n reactivity.
export function applyLocale(lang: string): void {
  i18n.locale = lang
  moment.locale(lang)
  document.documentElement.lang = lang
  const vuetifyLang = vuetifyInstance?.framework.lang
  if (vuetifyLang && vuetifyLang.locales[lang]) {
    vuetifyLang.current = lang
  }
}

export default i18n
